export const getFieldDisplayName = (field: string): string => {
  const fieldNames: Record<string, string> = {
    email: "email",
    firstName: "имя",
    lastName: "фамилия",
    position: "должность",
    networkingProfile: "профиль в Нетворкинге",
    networkingProfileCountry: "страна",
    networkingProfileCity: "город",
    networkingProfileEmploymentType: "тип занятости",
    workName: "название компании",
    networkingProfileCompanyTypes: "тип компании",
    networkingProfileinterestCompanyTypes:
      "с компаниями какого типа вы ищете контакты",
    networkingProfilelanguages:
      "на каком языке вы планируете общаться в нетворкинге",
    companyAssociation: "присоединитесь к странице вашей компании",
  };

  return fieldNames[field] || field;
};
